<template>
  <b-row>
    <b-col>

      <!-- 件数 -->
      <b-card class="mb-0 mt-0" body-class="p-2">
        <b-row>
          <!-- 表示情報変更中 -->
          <b-col cols="2">
            <span class="h7">
              <b class="ml-1" style="color: red;">
                <span>{{changeDisplayInformation}}</span>
              </b>
            </span>
          </b-col>
          <!-- エラーエッジ数 -->
          <b-col cols="2" offset="2">
            <span class="h7" :style="errorEdgeCount != 0 ? 'background-color: yellow; color: red;' : ''">
              <b class="ml-1">
                <span>異常エッジ数：</span>
              </b>
              <b class="ml-1">
                <span>{{errorEdgeCount}}</span>
              </b>
            </span>
          </b-col>
          <!-- 試運用・テスト中エッジ数 2023/03 ADD -->
          <b-col cols="2">
            <span class="h7" :style="alertStoppingCount != 0 ? 'background-color: yellow; color: red;' : ''">
              <b class="ml-1">
                <span>試運用・テスト中：</span>
              </b>
              <b class="ml-1">
                <span>{{alertStoppingCount}}</span>
              </b>
            </span>
          </b-col>
          <!-- AI監視停止中エッジ数 -->
          <b-col cols="2">
            <span class="h7" :style="surveillanceStoppingCount != 0 ? 'background-color: yellow; color: red;' : ''">
              <b class="ml-1">
                <span>監視停止エッジ数：</span>
              </b>
              <b class="ml-1">
                <span>{{surveillanceStoppingCount}}</span>
              </b>
            </span>
          </b-col>
          <!-- 最新更新日時 -->
          <b-col cols="2">
            <span class="h8" style="display: block; text-align: right;">更新時刻：{{lastScreenUpdateTime}}</span>
          </b-col>
        </b-row>
      </b-card>

      <!-- 検索条件 -->
      <b-card class="mb-0 mt-0" body-class="p-2">
        <b-row>
          <b-col>
            <span class="h5">
              <i class="fa fa-search"></i>
              <b class="ml-1">検索条件</b>
            </span>
          </b-col>
          <b-col cols="auto">
            <b-btn :class="visible ? null : 'collapsed'"
              :aria-expanded="visible ? 'true' : 'false'"
              aria-controls="collapse-1"
              @click="visible = !visible"
              class="ml-auto"
              variant="outline-secondary"
              size="sm">
              {{visible === true?`∧`:`∨`}}
            </b-btn>
          </b-col>
        </b-row>
        <b-collapse id="collapse-1" class="mt-2 mx-4" v-model="visible">
          <alert-history-search
            @msgShow="showChangeDisplayInformation">
          </alert-history-search>
        </b-collapse>
      </b-card>

      <!-- 通知・発報履歴一覧 -->
      <b-card>
        <b-table
          :items="filteredHistories"
          :fields="tableFields"
          :per-page="perPage"
          :current-page="currentPage"
          :empty-text="'データがありません'"
          hover
          responsive
          show-empty
          class="p-1 text-nowrap table-sm"
          no-local-sorting
          @row-clicked="tableRowClick">
          <!-- 踏切名 -->
          <template v-slot:cell(crossingName)="data">
            <span
              class="text-wrap text-center"
              style="font-size: 17px;">
              {{ data.item.crossingName }}
            </span>
          </template>
          <!-- 発報元 -->
          <template v-slot:cell(alertSourceAbbreviation)="data">
            <span
              class="text-wrap text-center"
              style="font-size: 17px;">
              {{ data.item.alertSourceAbbreviation }}
            </span>
          </template>
          <!-- 発生日時 -->
          <template v-slot:cell(alertReceiveTime)="data">
            <div style="font-size: 15px;">
              {{ data.item.alertReceiveTime }}
            </div>
          </template>
          <!-- 解除日時 -->
          <template v-slot:cell(alertCansellTime)="data">
            <div
              v-if="data.item.alertCansellTime != ''"
              style="font-size: 15px;">
              {{ data.item.alertCansellTime }}
            </div>
          </template>
          <!-- ライブカメラリンク -->
          <template v-slot:cell(liveCamLink)="data">
            <div v-if='data.item.safieToken != null'>
              <a
                @click="linkToOtherWindow(data)"
                href="javascript:void(0)"
              >
                <span>ライブカメラ</span>
              </a>
            </div>
          </template>
        </b-table>
        <b-pagination
          :total-rows="filteredHistories.length"
          :per-page="perPage"
          v-model.number="currentPage"
          align="center"
          class="mt-1 mb-0" />
      </b-card>
    </b-col>
  </b-row>
</template>
<script>

import API from '@/api'
import moment from 'moment';
import {mapGetters} from 'vuex';
import AlertHistorySearch from '../components/AlertHistorySearch';

const POLLING_INTERVAL = process.env.VUE_APP_POLLING_INTERVAL
const PER_PAGE = process.env.VUE_APP_ALERT_HISTORY_PER_PAGE
const GET_LIST_PROCESS_TYPE = 0
const TIME_FORMAT_MILLISECONDS = 'YYYY/MM/DD HH:mm:ss'
const WINDOW_FEATURES = "menubar=no,location=no,resizable=yes,scrollbars=yes,status=no,width=800,height=640"

const DEBUG = parseInt(process.env.VUE_APP_DEBUG)
const debug = msg => {
  if (DEBUG === 1)
    console.log(msg)
}

export default {
  name: "AlertHistory",
  components: {AlertHistorySearch},
  data() {
    return {
      // ダイアログを多重に表示させない為のフラグ
      alreadyDialogDisplayed: false,
      // エラーダイアログの表示状態
      alreadyErrorDialogDisplayed: false,

      // 定周期タイマー(検索結果一覧のリフレッシュ)
      searchConditionsTimer: null,

      // 画面最新更新日時
      lastScreenUpdateTime: null,

      // 表示情報変更
      changeDisplayInformation: '',

      // 件数
      errorEdgeCount: 0,
      surveillanceStoppingCount: 0,

      // 試運用・テスト中件数 2023/03 ADD
      alertStoppingCount: 0,

      // 検索条件のアコーディオン
      visible: false,

      // 通知・発報履歴一覧
      filteredHistories: [],
      // ページ
      currentPage: 1,

      // 検索条件の要素
      searchCrossingName: null,
      searchAlertDateFrom: null,
      searchAlertDateTo: null,
      searchCanselDateFrom: null,
      searchCanselDateTo: null,
      searchReporterSelected: [
        '0',
        '2',
        '4',
      ],
      searchTrialSelected: false,
    };
  },
  async created() {
    await this.initialize();
  },
  // 画面遷移時に定周期処理を停止する
  async beforeDestroy() {
    clearInterval(this.searchConditionsTimer)
  },
  methods: {
    //初期処理
    async initialize() {
      const data = await this.fetchAlertHistories()
      this.bindingFilteredHistories(data)
      // 自動更新の設定
      this.setAlertHistoryAutoRefreshTimer(true)
    },

    clearFilteredHistories(){
      this.filteredHistories = []
      this.errorEdgeCount = 0
      this.surveillanceStoppingCount = 0
      this.alertStoppingCount = 0 // 試運用・テスト中件数 2023/03 ADD
    },

    bindingFilteredHistories(data){
      const results = []
      if (data) {
        this.lastScreenUpdateTime = moment().format("HH:mm:ss")
        data.alertHistory.forEach(function(data) {
          // フォーマット
          const result = {}
          result.alertHistoryId = data.alertHistoryId
          result.crossingName = data.crossingName
          result.locationName = data.locationName
          result.alertReceiveTime = moment(data.occurrenceReceiveJst).format(TIME_FORMAT_MILLISECONDS)
          result.alertReceiveImageUrl = data.occurrenceImageUrl
          result.safieId = data.safieId
          result.safieDeviceId = data.safieDeviceId
          result.safieToken = data.safieToken
          // 解除日時が設定されていない場合
          if (data.releaseReceiveJst == null) {
            result.alertCansellTime = ''
            result.alertCansellImageUrl = ''
            result._rowVariant = 'danger'
          } else {
            result.alertCansellTime = moment(data.releaseReceiveJst).format(TIME_FORMAT_MILLISECONDS)
            result.alertCansellImageUrl = data.releaseImageUrl
            result._rowVariant = ''
          }
          // 通知・発報種別が異常通知(0)の場合
          if (data.alertType == 0) {
            result.alertSourceName = 'AIカメラ検知'
            result.alertSourceAbbreviation = 'AIカメラ検知'
            // 通知・発報種別が障検装置発報(2)の場合
          } else if (data.alertType == 2) {
            result.alertSourceName = '障検動作'
            result.alertSourceAbbreviation = '障検動作'
            // 通知・発報種別が非常ボタン発報(4)の場合
          } else if (data.alertType == 4) {
            result.alertSourceName = '押しボタン操作'
            result.alertSourceAbbreviation = '押しボタン操作'
          }
          results.push(result)
        })
        this.filteredHistories = results
        this.errorEdgeCount = data.errorEdge
        this.surveillanceStoppingCount = data.surveillanceStopping
        this.alertStoppingCount = data.alertStopping // 試運用・テスト中件数 2023/03 ADD
      }
    },

    async showChangeDisplayInformation(value, searchCrossingName, alertDateFrom, alertDateTo, searchReporterSelected,
      searchTrialSelected, canselDateFrom, canselDateTo) {
        // 定周期処理の解除
        clearInterval(this.searchConditionsTimer)

        // 検索ボタン押下時の処理
        if (value) {
          this.changeDisplayInformation = '表示情報変更中'
          this.searchCrossingName = searchCrossingName
          this.alertDateFrom = alertDateFrom
          this.alertDateTo = alertDateTo
          this.searchReporterSelected = searchReporterSelected
          this.searchTrialSelected = searchTrialSelected
          this.canselDateFrom = canselDateFrom
          this.canselDateTo = canselDateTo
          const data = await this.searchAlertHistories(true)
          this.bindingFilteredHistories(data)
          // 検索結果自動更新の設定
          if (data) {
            this.setAlertHistoryAutoRefreshTimer(false)
          } else {
            this.clearFilteredHistories()
            this.changeDisplayInformation = '検索エラーのため表示更新を中断'
          }
        // クリアボタン押下時の処理
        } else {
          this.changeDisplayInformation = ''
          this.searchCrossingName = null
          this.searchAlertDateFrom = null
          this.searchAlertDateTo = null
          this.searchCanselDateFrom = null
          this.searchCanselDateTo = null
          this.searchReporterSelected = [
            '0',
            '2',
            '4',
          ]
          this.searchTrialSelected = false
          const data = await this.fetchAlertHistories()
          this.bindingFilteredHistories(data)
          // 検索結果自動更新の設定
          this.setAlertHistoryAutoRefreshTimer(true)
        }
    },

    async tableRowClick(record) {
      const modal = await this.createModal(record)
      this.showModal(modal)
    },

    async createModal(record, h = this.$createElement) {
      let errorMes = ''
      const receiveImageUrl = await this.getAlertImageFile(record.alertReceiveImageUrl)
      if (receiveImageUrl != null) {
        record.alertReceiveImageUrl = receiveImageUrl
      } else {
        record.alertReceiveImageUrl = ''
        errorMes = errorMes + '発生時の現場画像取得に失敗しました\n'
      }
      if (record.alertCansellImageUrl != '') {
        const cansellImageUrl = await this.getAlertImageFile(record.alertCansellImageUrl)
        if (cansellImageUrl != null) {
          record.alertCansellImageUrl = cansellImageUrl
        } else {
          record.alertCansellImageUrl = ''
          errorMes = errorMes + '解除時の現場画像取得に失敗しました\n'
        }
      }
      if (errorMes != '') {
        await this.showErrorDialog(errorMes)
      }

      const title = this.selectTitle(h, record)
      const message = this.createModalMessage(record, h)
      return {title, message}
    },

    // 行クリック時に表示するモーダル
    createModalMessage(record, h) {
      return h('b-row', {class: 'no-gutters'}, [
        h('b-col', {class: ''}, [
          h('b-row', {}, [
            h('b-col', {
              class: 'cols-6 d-flex  flex-wrap',
              props: {
                sm:"4"
              }
            }, [
              h('span', {class: 'h1 align-self-end text-truncate'}, [
                h('span', {
                    class: 'h3',
                    directives: [
                      {
                        name: 'b-tooltip',
                        value: record.crossingName,
                        modifiers: {
                          left: true,
                        }
                      },
                    ],
                  },
                  `${record.crossingName}`),
              ]),
            ]),
            h('b-col', {
              class: 'cols-6 d-flex  flex-wrap',
              props: {
                sm:"4"
              }
            }, [
              h('span', {class: 'h1 align-self-end text-truncate'}, [
                h('span', {class: 'h3'},`カメラ設置場所 : ${record.locationName}`),
              ]),
            ]),
            h('b-col', {
              class: 'cols-6 d-flex  flex-wrap',
              props: {
                sm:"4"
              }
            }, [
              h('span', {class: 'h1 align-self-end text-truncate'}, [
                h('span', {class: 'h3'},`発報元 : ${record.alertSourceName}`),
              ]),
            ]),
          ]),
          h('b-row', {class: ''}, [
            h('b-col', {class: 'cols-12'}, [
              h('span', {class: "h5 ml-auto align-self-end"}, [
                h('span', {class: 'text-muted '}, `発生日時 : ${record.alertReceiveTime} `),
              ]),
              h('b-img-lazy', {
                class: 'modal-image',
                props: {
                  src: record.alertReceiveImageUrl,
                  center: true,
                  width: 800,
                  height: 600,
                  blankColor: "#99999999",
                  fluid: true,
                  alt: '発生時の現場画像',
                }
              }),
            ]),
            h('b-col', {class: 'cols-12'}, [
              h('span', {class: "h5 ml-auto align-self-end"}, [
                h(
                  'span',
                  {class: 'text-muted '},
                  `解除日時 :
                    ${
                      this.releaseDataOutput(
                        record.alertCansellTime, record.alertCansellTime !=""
                      )
                    }
                  `),
              ]),

              h('div',{},
                [
                  this.releaseDataOutput(
                    h('b-img-lazy', {
                      class: 'modal-image',
                      props: {
                        src: record.alertCansellImageUrl,
                        center: true,
                        width: 800,
                        height: 600,
                        blankColor: "#99999999",
                        fluid: true,
                        alt: '解除時の現場画像',
                      }
                    }),
                    record.alertCansellImageUrl !=""
                  ),
                ]
              ),
            ]),
          ]),
        ])
      ])
    },

    // 一覧取得(検索条件なし)
    async fetchAlertHistories() {
      try {
        const result = await API.alertHistory.get(this.idToken(), {
          path: '?client_id=' + this.clientId +
                '&affiliation_id=' + this.affiliationId +
                '&process_type=' + GET_LIST_PROCESS_TYPE
        })
        return result.data
      } catch (err) {
        // セッションタイムアウト判定
        if (err.response && err.response.status === 403) {
          return this.$router.push({path: '/session-timeout'})
        } else {
          this.makeToast(
            '通知・発報履歴一覧の取得エラー',
            `通知・発報履歴一覧の取得に失敗しました。(${err.message})`,
            'warning')
        }
        return
      }
    },
    // 一覧取得(検索条件あり)
    async searchAlertHistories(onErrorShowDialog = true) {
      try {
        const result = await API.alertHistory.get(this.idToken(), {
          path: this.setPath()
        })
        return result.data
      } catch (err) {
        // セッションタイムアウト判定
        if (err.response && err.response.status === 403) {
          return this.$router.push({path: '/session-timeout'})
        } else {
          if (onErrorShowDialog) {
            await this.showErrorDialog(`検索に失敗しました。(${err.message})`)
          } else {
            this.makeToast(
              '通知・発報履歴一覧(検索条件指定)の取得エラー',
              `通知・発報履歴一覧(検索条件指定)の取得に失敗しました。(${err.message})`,
              'warning')
          }
        }
        return
      }
    },
    // 通知バナーの表示
    makeToast(title, message, variant = 'info') {
      this.$bvToast.toast(message, {
        title: title,
        autoHideDelay: 8000,
        variant: 'warning',
      })
    },
    // 検索時のリクエストパラメータの設定
    setPath() {
      var setPath = []
      setPath.push('?client_id=' + this.clientId)
      setPath.push('&affiliation_id=' + this.affiliationId)
      setPath.push('&process_type=' + GET_LIST_PROCESS_TYPE)
      // 踏切名
      if (this.searchCrossingName !== null) {
        setPath.push('&crossing_name=' + this.searchCrossingName)
      }
      // 発生日時From
      if (this.alertDateFrom !== null) {
        setPath.push('&alert_date_from=' + moment(this.alertDateFrom).utc().format())
      }
      // 発生日時To
      if (this.alertDateTo !== null) {
        setPath.push('&alert_date_to=' + moment(this.alertDateTo).utc().format())

      }
      // 発報元
      setPath.push('&reporter=' + this.searchReporterSelected)
      // 試運用フラグ
      setPath.push('&trial=' + this.searchTrialSelected)
      // 解除日時From
      if (this.canselDateFrom !== null) {
        setPath.push('&cansel_date_from=' + moment(this.canselDateFrom).utc().format())
      }
      // 解除日時To
      if (this.canselDateTo !== null) {
        setPath.push('&cansel_date_to=' + moment(this.canselDateTo).utc().format())
      }
      return setPath.join('')
    },
    createSearchErrorMessage(error) {
      let result = error.response.data
      return result
    },
    async showModal(modal) {
      if (this.alreadyDialogDisplayed) return true
      this.alreadyDialogDisplayed = true

      await this.$bvModal.msgBoxOk(
        [modal.message],
        {
          okTitle: '閉じる',
          hideHeaderClose: true,
          noCloseOnEsc: false,
          noCloseOnBackdrop: false,
          centered: true,
          size: 'xl',
          headerClass: 'p-0 border-bottom-0',
          bodyClass: 'pb-0',
          footerClass: 'pb-2 border-top-0',
          buttonSize: 'md',
        }
      ).catch(() => {
          this.alreadyDialogDisplayed = false
      })
      this.alreadyDialogDisplayed = false
    },
    // 定周期で動作する関数
    setAlertHistoryAutoRefreshTimer(isDefaultSearchCondition) {
      if (isDefaultSearchCondition) {
        let isInProgress = false;
        this.searchConditionsTimer = setInterval(async () => {
          if (isInProgress) return
          isInProgress = true
          try {
            const data = await this.fetchAlertHistories()
            this.bindingFilteredHistories(data)
          } catch (err) {
            debug(err)
          } finally {
            isInProgress = false
          }
        }, POLLING_INTERVAL)
      } else {
        let isInProgress = false;
        this.searchConditionsTimer = setInterval(async () => {
          if (isInProgress) return
          isInProgress = true
          try {
            const data = await this.searchAlertHistories(false)
            this.bindingFilteredHistories(data)
          } catch (err) {
            debug(err)
          } finally {
            isInProgress = false
          }
        }, POLLING_INTERVAL)
      }
    },

    selectTitle(h, history) {
      return history.isAlert
        ? h('span', {class: 'text-danger'}, `${history.alertSourceName}で危険を検知しました。`)
        : h('span', {}, `${history.alertSourceName}からの発報を解除しました。`)
    },

    releaseDataOutput(contents, flag) {
      if (!flag) {
        return ''
      }
      return contents
    },

    // エラーダイアログ
    async showErrorDialog(errorMessage) {
      this.alreadyDialogDisplayed = true
      // 既にエラーダイアログが表示されている場合は重ねて表示しない
      if (this.alreadyErrorDialogDisplayed === true) return
      this.alreadyErrorDialogDisplayed = true
      await this.$bvModal.msgBoxOk(
        `${errorMessage}`, this.errorDialogProps)
        .then(async () => {
        })
        .catch(() => {
          this.alreadyDialogDisplayed = false
          this.alreadyErrorDialogDisplayed = false
        })
      this.alreadyDialogDisplayed = false
      this.alreadyErrorDialogDisplayed = false
    },

    // 画像ファイル取得(return URL)
    async getAlertImageFile(imageUrl) {
      try {
        const soundUrl = '?filePath=' + imageUrl
        const downLoadFileResult = await API.fileDownLoad.downLoadFile(
          this.idToken(),
          {
            'Content-Type': 'image/jpeg',
            path: soundUrl
          }
        )
        const blob = new Blob([downLoadFileResult], {type: "image/jpeg"})
        return window.URL.createObjectURL(blob)
      } catch (error) {
        return null
      }
    },
    // ライブカメラリンク押下
    linkToOtherWindow(data) {
      let resolvedRoute = this.$router.resolve({
        name: 'LiveCamera',
        query: {
          safieToken: data.item.safieToken,
          safieDeviceId: data.item.safieDeviceId,
        }
      })
      const windowName = 'LiveCamera_' + data.item.safieDeviceId
      let test = window.open(resolvedRoute.href, windowName, WINDOW_FEATURES)
    },
  },
  computed: {
    ...mapGetters("auth", ['idToken','clientId','affiliationId']),
    tableFields() {
      return [
        {
          key: "crossingName",
          label: "踏切名",
          sortable: false,
        },
        {
          key: "alertSourceAbbreviation",
          label: "発報元",
          sortable: false,
        },
        {
          key: "locationName",
          label: "カメラ設置場所",
          sortable: false,
        },
        {
          key: "alertReceiveTime",
          label: "発生日時",
          sortable: false
        },
        {
          key: "alertCansellTime",
          label: "解除日時",
          sortable: false
        },
        {
          key: "liveCamLink",
          label: "ライブカメラ",
          sortable: false,
        }
      ]
    },
    perPage() {
      return PER_PAGE
    },

    errorDialogProps() {
      return {
        title: 'エラー',
        headerBgVariant: 'danger',
        hideHeaderClose: true,
        noCloseOnEsc: true,
        noCloseOnBackdrop: true
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .modal-image {
    width: auto;
    height: auto;
    max-height: calc(100vh - 180px);
  }

  .px-12p {
    padding-left: 12px;
    padding-right: 12px;
  }

  .test-dialog-class {
    height : 850px;
  }

</style>
